import { ComponentL, ComponentM, ComponentTextStyle } from "@laerdal/life-react-components";
import { useTranslation } from "react-i18next";
import { NoResults, NoResultsContainer } from "../ArticleSearchPage.styles";

interface ArticleSearchNoResultsProps {
  searchTerm: string;
}

const ArticleSearchNoResults = ({ searchTerm }: ArticleSearchNoResultsProps) => {
  const { t } = useTranslation("articles");

  return (
    <NoResults>
      <NoResultsContainer>
        <ComponentL textStyle={ComponentTextStyle.Bold}>{t('The search did not return any results')}</ComponentL>
        <ComponentM>{t('There are no results for {{searchTerm}}', { searchTerm })}</ComponentM>
      </NoResultsContainer>

      <NoResultsContainer>
        <ComponentL textStyle={ComponentTextStyle.Bold}>{t('')}</ComponentL>
        <ComponentM>&#9679; {t('Try searching by product type or SKU number')}</ComponentM>
        <ComponentM>&#9679; {t('Check the spelling or try other keywords')}</ComponentM>
      </NoResultsContainer>

      <NoResultsContainer>
        <ComponentL textStyle={ComponentTextStyle.Bold}>{t('Need help?')}</ComponentL>
        <ComponentM>{t('Feel free to reach out if you are experiencing any difficulties.')}</ComponentM>
      </NoResultsContainer>
    </NoResults>
  );
};

export default ArticleSearchNoResults;
